import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
//import { PopupComponent } from 'libs/iot-platform-ui/src/lib/ui/components/popup/popup.component';
import { NotificationService } from './notification.service';

@Component({
  selector: 'iot-platform-notification',
  templateUrl: './notification.component.html'
})
export class NotificationComponent {
  constructor(private snackBar: MatSnackBar, public notificationService: NotificationService, private dialog: MatDialog) {
    this.notificationService.error$.subscribe((value: string) => this.displayError(value));
    this.notificationService.success$.subscribe((value: string) => this.displaySuccess(value));
  }

  private displaySuccess(message: string, action: string = '', duration: number = 4000) {
    this.snackBar.open(message, action, { duration: duration });
  }

  private displayError(value: string) {
    /*const dialogRef = this.dialog.open(PopupComponent, {
      width: '500px',
      disableClose: true,
      data: { type: 'error', value: value }
    });

    dialogRef.afterClosed();*/
  }
}
